export const en = {
  badge: "Magdi Hegazy Textile",
  heroTitle: "Quality fabric printing with dependable factory service.",
  heroText:
    "We help brands, wholesalers, and manufacturers bring textile designs to life with clean printing, consistent output, and responsive support.",
  callUs: "Call Us",
  emailUs: "Email Us",
  countries: "Countries We Serve",
  countriesValue: "3",
  clients: "Clients Served",
  clientsValue: "40+",
  offerLabel: "What We Offer",
  offerTitle: "Clear information, strong presentation.",
  h1Title: "Precision Textile Printing",
  h1Desc:
    "High-quality fabric printing for fashion, uniforms, promotional materials, and custom production runs.",
  h2Title: "Reliable Turnaround",
  h2Desc:
    "From sample development to bulk production, we focus on consistent timelines and dependable communication.",
  h3Title: "Custom Orders Welcome",
  h3Desc:
    "We support a range of patterns, colors, finishes, and fabric requirements tailored to your project.",
  aboutLabel: "About the Factory",
  aboutTitle: "Built to support textile production with care and consistency.",
  aboutText1:
    "Our factory serves clients looking for professional textile printing backed by practical manufacturing experience. Whether you need repeatable patterns, brand-specific colors, or production support for custom fabrics, we aim to deliver clean results and a straightforward working process.",
  aboutText2:
    "",
  contactLabel: "Contact Info",
  phone: "Phone",
  email: "Email",
  address: "Address",
  hours: "Working Hours",
  phoneValue: "+201118506001",
  emailValue: "sales@magdihegazy.com",
  addressValue: "201 block 800, Badr City, Egypt",
  hoursValue: "Saturday – Thursday, 8:00 AM – 6:00 PM",
  switchLanguage: "العربية",
};
